import { h } from 'preact';

import StyleCard from './style-card';

const StyleGrid = ({ isHidden, styles }) => {
  const sortedStyles = styles.sort((a, b) => a.sort_order - b.sort_order);

  return (
    <div className={`mt-15 grid grid-cols-2 gap-8 md:grid-cols-3 ${isHidden ? 'hidden' : ''}`}>
      {sortedStyles.map((style) => (
        <StyleCard
          key={style.id}
          style={style}
        />
      ))}
    </div>
  );
};

export default StyleGrid;
